<template>
    <div>
        <label>{{ label }}</label>
        <b-form-group
            :label="$t('component')"
            v-if="onlyComponent === null"
        >
            <v-select :options="components" :value="component.label" @option:selected="componentChanged" />
        </b-form-group>

        <b-form-group
            :label="$t('template')"
        >
            <v-select :options="possibleEntrypoints" v-model="content" taggable/>
        </b-form-group>
    </div>
</template>

<style scoped>
.custom-control-label:after, .custom-control-label:before {
   display: none !important;
}
</style>

<script>
import VSelect from 'vue-select'
// import { Builder } from 'protokol-sdk'

export default {
    components: {
        VSelect
    },
    props: {
        value: {
            type: Object
        },

        label: {
            type: String
        },

        onlyComponent: {
            type: String,
            default: null
        }
    },

    data: function() {
        return {
            modules: [],
            components: [],
            selectedComponent: null
        }
    },

    computed: {
        content: {
            get() {
                return this.value.template
            },

            set(v) {
                this.$emit('input', {
                    component: this.selectedComponent,
                    template: v,
                })
            }
        },

        component() {
            return this.components.find(c => c.code === this.selectedComponent) || {label: this.$t('unknown')}
        },   

        possibleEntrypoints() {
            return this.modules.filter(m => {
                return m.includes(".vue")
            }).map(m => {
                return m.replace(".vue", "")
            })
        },

        nodes() {
            return this.settings.settings.templates
        },

        dist() {
            const { dist } = this.settings.settings.templates_dist || {}
            return dist
        },

        settings() {
            return this.$store.getters.componentSettings(this.selectedComponent)
        }
    },

    methods: {
        async componentChanged(v) {
            this.selectedComponent = v.code
            const settings = await this.$store.dispatch("fetchComponentsSettings", v.code)

            const { templates_dist } = settings.settings
            if (templates_dist && templates_dist.sdk_version < 6) {
                if (this.dist) {
                    this.modules = Object.keys(this.dist)
                    return
                }

                this.loadNodes(this.nodes || [])
            }
        }
    },

    mounted() {
        this.components = this.$store.getters.components.map(c => {
            return {
                label: this.$translateLabel(c.label, c.name),
                code: c.getRef()
            }
        })

        if (this.onlyComponent) {
            this.componentChanged({ code: this.onlyComponent })
        }

        this.selectedComponent = this.value.component
    }
}
</script>
